import { useTranslation } from 'react-i18next';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

export type IBaseDataTaxPickerProps<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export function BillableStatusPicker<TMultiple extends boolean>(
  props: IBaseDataTaxPickerProps<TMultiple>
) {
  const { ...rest } = props;

  const { t } = useTranslation();

  const dataSet = [
    {
      id: true,
      name: t('APPOINTMENT.BILLABLE'),
    },
    {
      id: false,
      name: t('APPOINTMENT.NON_BILLABLE'),
    },
  ];

  return <FixedDataPicker dataSet={dataSet} {...rest} />;
}
